import { Action } from '@ngrx/store';
import { CustomerContacts } from '@appRoot/core/customer/models';


export enum ActionTypes {
    RESET = '[Customer contacts storage] RESET',
    ADD_ONE = '[Customer contacts storage] ADD_ONE',
    UPSERT_ONE = '[Customer contacts storage] UPSERT_ONE',
    UPSERT_MANY = '[Customer contacts storage] UPSERT_MANY',
    UPDATE_ONE = '[Customer contacts storage] UPDATE_ONE',
    REMOVE_ONE = '[Customer contacts storage] REMOVE_ONE',
    REMOVE_MANY = '[Customer contacts storage] REMOVE_MANY',
}

export class Reset implements Action {
    readonly type = ActionTypes.RESET;
}

export class AddOne implements Action {
    readonly type = ActionTypes.ADD_ONE;

    constructor(readonly payload: CustomerContacts) { }
}

export class UpsertOne implements Action {
    readonly type = ActionTypes.UPSERT_ONE;

    constructor(readonly payload: CustomerContacts) { }
}

export class UpsertMany implements Action {
    readonly type = ActionTypes.UPSERT_MANY;

    constructor(readonly payload: CustomerContacts[]) { }
}

export class UpdateOne implements Action {
    readonly type = ActionTypes.UPDATE_ONE;

    constructor(readonly payload: CustomerContacts) { }
}

export class RemoveOne implements Action {
    readonly type = ActionTypes.REMOVE_ONE;

    constructor(readonly payload: CustomerContacts) { }
}

export class RemoveMany implements Action {
    readonly type = ActionTypes.REMOVE_MANY;

    constructor(readonly payload: CustomerContacts[]) { }
}


export type Actions =
    | Reset
    | AddOne
    | UpsertOne
    | UpsertMany
    | UpdateOne
    | RemoveOne
    | RemoveMany
    ;
